import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
import { Observable } from 'rxjs';
import { reduce, takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { environment } from 'src/environments/environment';
import { CsvService } from 'src/app/service/csv-service/csv.service';
import * as moment from 'moment';
import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';
import { CorporateService } from 'src/app/component/corporate-user/corporate-service/corporate-service';
import { DispatchCenterService } from 'src/app/component/dashboard/dashboard-service/dispatch-center-service';
import { LevelOfServiceService } from 'src/app/component/level-of-service/service/level-of-service.service';
import { sweetAlert } from 'src/app/utils/swal';
import { checkRole } from 'src/app/utils/utils.common';
import { UserRoles } from 'src/app/component/shared/layout/menu-service/menu.service';
import { DriversService } from 'src/app/component/drivers/drivers-service/drivers-service';
import { AuthService } from 'src/app/service/auth-service/auth.service';
import { FleetService } from 'src/app/component/fleet/fleet-service/fleet.service';

@Component({
  selector: 'app-trip-details',
  templateUrl: './trip-details.component.html',
  styleUrls: ['./trip-details.component.css']
})
export class TripDetailsComponent implements OnInit, OnDestroy {
  @ViewChild(GoogleMap, { static: false }) googleMap: GoogleMap;
  @Input() tripId: any
  @Input() openFrom?: any
  @Output() onCloseModal = new EventEmitter<any>();
  address: string;
  zoom: number;
  jobId;
  trackinURL;
  tripDetails = null;
  jobAcceptedUrl = null;
  jobOnSceneUrl = null;
  jobStartedUrl = null;
  jobEndedUrl = null;
  jobFinishedUrl = null;
  jobCancelledUrl = null;
  mapOptions: google.maps.MapOptions = {
    mapTypeId: 'satellite',
    fullscreenControl: true,
    mapTypeControl: true,
    mapTypeControlOptions: {
      position: google.maps.ControlPosition.TOP_LEFT
    }
  };
  isDrawRoute = false;
  origin = { lat: 0.00000, lng: 0.00000 };
  destination = { lat: 0.00000, lng: 0.00000 };
  assign;
  cameraImages;
  user;
  tripAssistance: {
    displayName: '',
    contactNumber: ''
  };
  contact
  timeZone
  todayDate = [];
  isAllowRates = false;
  isFarmoutIntegration = false;
  fleetData;
  driverList:any;
  selectedStatus = 'active';
  preDrivers = {};
  preferredDriverDetails:any

  // assistedDriver;
  constructor(
    private driverService: DriversService,
    private levelOfServiceService : LevelOfServiceService,
    private corporateService: CorporateService,
    private dispatchCenterService: DispatchCenterService,
    private assigTripsService: AssigTripsService,
    private sharedDataService: SharedDataService,
    private csvService: CsvService,
    private authService: AuthService,
    private fleetService: FleetService
  ) { }

  ngOnInit() {
    this.trackinURL = environment.TRACKING_URL;
    this.jobId = this.tripId;
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          if (user.hasOwnProperty('isFarmout')) {
            this.isFarmoutIntegration = user.isFarmout;
          }
          this.timeZone = user.timeZone;
          this.todayDate = [
            moment.tz(this.timeZone).startOf("day").toISOString(),
            moment.tz(this.timeZone).endOf("day").toISOString(),
          ];

          this.getCompletedTripDetail();
          this.isAllowRates = checkRole(this.user);
        }
      });
  }


  getFleetbyId() {
    this.fleetService
      .getFleetDataById(this.tripDetails.fleet)
      .subscribe((data) => {
        if (data) {
          this.fleetData = data;
        }
      });
  }

  twodigit(val) {
    return parseFloat(parseFloat(val).toFixed(2));
  }

  agmMap: google.maps.Map;

  onMapReady(map: google.maps.Map) {
    this.agmMap = map;
    this.updateBounds();
  }

  updateBounds() {
    setTimeout(() => {
      if (!this.agmMap) return;
      const bounds = new google.maps.LatLngBounds();
      let hasPoints = false;
      const oLat = parseFloat(this.origin.lat as any);
      const oLng = parseFloat(this.origin.lng as any);
      if (!isNaN(oLat) && !isNaN(oLng) && oLat !== 0) {
        bounds.extend({ lat: oLat, lng: oLng });
        hasPoints = true;
      }
      
      const dLat = parseFloat(this.destination.lat as any);
      const dLng = parseFloat(this.destination.lng as any);
      if (!isNaN(dLat) && !isNaN(dLng) && dLat !== 0) {
        bounds.extend({ lat: dLat, lng: dLng });
        hasPoints = true;
      }

      if (this.tripDetails && this.tripDetails.job && this.tripDetails.job.trackInfoJob) {
        const track = this.tripDetails.job.trackInfoJob;
        const points = [
          track.jobAccepted,
          track.jobArrived,
          track.jobStarted,
          track.jobCompleted,
          track.jobFinished,
          track.jobCancelled
        ];
        points.forEach(p => {
          if (p && p.coords && p.coords.length >= 2) {
            const pLat = parseFloat(p.coords[1]);
            const pLng = parseFloat(p.coords[0]);
            if (!isNaN(pLat) && !isNaN(pLng) && pLat !== 0) {
              bounds.extend({ lat: pLat, lng: pLng });
              hasPoints = true;
            }
          }
        });
      }

      if (hasPoints) {
        this.agmMap.fitBounds(bounds);
      }
    }, 500);
  }

  closeDetailModal() {
    this.onCloseModal.emit();
  }

  breakString(str) {
    if (!str) return "";
    return str.replace(/\n/g, "<br>");
  }

  isStringExist(substrings, str) {
    if (substrings.some(v => str.toLowerCase().includes(v))) {
      return true;
    }
    return false;
  }

  sendSMS() {
    if (!this.tripAssistance.displayName || !this.tripAssistance.contactNumber) return;
    this.assigTripsService
      .sendTripAssistanceSMS(this.tripDetails._id, this.tripAssistance)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          if (data.success) {
            sweetAlert('Success', data.message + ' ' + data.link, 'success', 'OK');
          } else {
            sweetAlert('Error', data.message, 'error', 'OK');
          }
        }
      });
  }

  sendTrackingSMS() {
    if (!this.contact) return;
    this.tripDetails.contactNumber = this.contact;

    const payload = {
      ...this.tripDetails,
      tripId: this.tripDetails._id,
      latitude: this.tripDetails.driver.latitude,
      longitude: this.tripDetails.driver.longitude,
    }
    this.assigTripsService
      .sendTrackingSMS(payload)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          // this.contact = '';
          if (data.success) {
            sweetAlert('Success', data.message, 'success', 'OK');
          } else {
            sweetAlert('Error', data.message, 'error', 'OK');
          }
        }
      });
  }

  getCompletedTripDetail() {
    this.dispatchCenterService.getTripDetail(this.jobId).subscribe(async (data) => {
      if (data) {
        this.tripDetails = data;
        console.log('tripDetails', this.tripDetails);

        // if(this.tripDetails.attendees){
        //   this.getAssistByid(this.tripDetails.attendees);
        // }

        this.tripAssistance = {
          displayName: this.tripDetails.priorityClient.displayName,
          contactNumber: this.tripDetails.priorityClient.contactNumber
        };


        if (this.tripDetails.job && this.tripDetails.job.trackInfoJob) {

          if (this.tripDetails.job.trackInfoJob.jobAccepted)
          this.jobAcceptedUrl = await this.loadStaticMap(this.tripDetails.job.trackInfoJob.jobAccepted.coords[1],
            this.tripDetails.job.trackInfoJob.jobAccepted.coords[0]);

            if (this.tripDetails.job.trackInfoJob.jobArrived)
          this.jobOnSceneUrl = await this.loadStaticMap(this.tripDetails.job.trackInfoJob.jobArrived.coords[1],
            this.tripDetails.job.trackInfoJob.jobArrived.coords[0]);

            if (this.tripDetails.job.trackInfoJob.jobStarted)
          this.jobStartedUrl = await this.loadStaticMap(this.tripDetails.job.trackInfoJob.jobStarted.coords[1],
            this.tripDetails.job.trackInfoJob.jobStarted.coords[0]);

            if (this.tripDetails.job.trackInfoJob.jobCompleted)
          this.jobEndedUrl = await this.loadStaticMap(this.tripDetails.job.trackInfoJob.jobCompleted.coords[1],
            this.tripDetails.job.trackInfoJob.jobCompleted.coords[0]);

            if (this.tripDetails.job.trackInfoJob.jobFinished)
          this.jobFinishedUrl = await this.loadStaticMap(this.tripDetails.job.trackInfoJob.jobFinished.coords[1],
            this.tripDetails.job.trackInfoJob.jobFinished.coords[0]);

            if (this.tripDetails.job.trackInfoJob.jobCancelled)
          this.jobCancelledUrl = await this.loadStaticMap(this.tripDetails.job.trackInfoJob.jobCancelled.coords[1],
            this.tripDetails.job.trackInfoJob.jobCancelled.coords[0]);
        }

        this.origin = {
          lat: this.tripDetails.jobOriginLatitude,
          lng: this.tripDetails.jobOriginLongitude
        };
        this.destination = {
          lat: this.tripDetails.jobDestinationLatitude,
          lng: this.tripDetails.jobDestinationLongitude
        };
        if(this.tripDetails.preferredDriver){
          this.getPreferredDriverData(this.tripDetails.preferredDriver);
        }
          
        this.getCorporateUserById();
        this.getLevelOfServicebyId();
        this.getSpaceTypesbyId();
        this.getFleetbyId();
        if(this.tripDetails && this.tripDetails.job)
        this.getUploadedCameraImages(this.tripDetails.job._id, this.tripDetails._id);

        this.updateBounds();
      }
    })
  }

  getUploadedCameraImages(jobId, assignId) {
    this.dispatchCenterService
      .getCameraImages(jobId, assignId)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.cameraImages = data;
        }
      });
  }


  getCorporateUserById() {
    this.corporateService.getCorporateUserById(this.tripDetails.cooperate)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.tripDetails.cooperate = data.displayName
          this.contact = data.contactNumber
        }


      });
  }

  getLevelOfServicebyId(){
    this.levelOfServiceService.getLevelOfServicebyId(this.tripDetails.los)
    .pipe(takeUntil(takeUntilDestroyed(this)))
    .subscribe(
      (data) => {
        if (data) {
          this.tripDetails.los = data.title
        }
      },

    );
  }

  getSpaceTypesbyId() {
    this.levelOfServiceService.getServiceTypebyId(this.tripDetails.spaceType)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
           this.tripDetails.spaceType = data.title
          }
        },

      );
  }

  // getAssistByid(assistId) {
  //   this.driverService
  //     .getDriversByID(assistId)
  //     .pipe(takeUntil(takeUntilDestroyed(this)))
  //     .subscribe(data => {
  //       if (data) {
  //         this.assistedDriver = data;
  //         console.log('assistedDriver', this.assistedDriver);
  //       }
  //     });
  // }

  loadStaticMap = async (lat, lng) => {
    let mapKey = '';
    const res = await this.authService.getGoogleKeys().toPromise();
    if (res && res.key) {
      console.log('Load static map API key:');
      mapKey = res.key;
    } else {
      console.error('Error load static map API key');
    }
    let url = 'https://maps.googleapis.com/maps/api/staticmap?center='
      + lat + ',' + lng + '&zoom=18&size=500x500&maptype=satellite&markers=color:red|' + lat
      + ',' + lng + '&key=' + mapKey;

    return url;
  }

  getPreferredDriverData(driverId) {
    this.driverService
      .getDriversByID(driverId)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preferredDriverDetails = data;
        }
      });
  }

  ngOnDestroy(): void {
  }

}
